export function validateThaiCitizenID(id: string): boolean { 
    if(id && id?.length === 13){
 id = id?.replace(/\D/g, "")
  

    const digits = id?.split("").map(Number)
    let sum = 0
    for (let i = 0; i < 12; i++) {
      sum += digits[i] * (13 - i)
    }

    const checksum = (11 - (sum % 11)) % 10

    return digits[12] === checksum
    }else{
        return false
    }
   
}